import { motion } from "framer-motion";
import { Eye, Target } from "lucide-react";

const ITEMS = [
  {
    icon: Eye,
    key: "vision",
    title: "Vision",
    body: "Trasformare la sicurezza da obbligo normativo a cultura, consapevolezza e valore quotidiano.",
  },
  {
    icon: Target,
    key: "mission",
    title: "Mission",
    body: "Offrire formazione, consulenza e soluzioni concrete per prevenire i rischi, migliorare i comportamenti e proteggere le persone.",
  },
];

export const VisionMission = () => {
  return (
    <section data-testid="vision-mission-section" className="py-16 md:py-20 bg-brand-paper border-b border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-6">
        {ITEMS.map((item, i) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={item.key}
              data-testid={`${item.key}-card`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="border border-border bg-white p-8 md:p-10"
            >
              <div className="flex items-center gap-3 mb-5">
                <span className="w-10 h-10 rounded-full border-2 border-brand-red flex items-center justify-center text-brand-red">
                  <Icon size={18} />
                </span>
                <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red">{item.title}</span>
              </div>
              <p className="font-heading text-2xl md:text-3xl font-bold text-brand-black leading-tight">
                {item.body}
              </p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
